import { render, staticRenderFns } from "./PostprocessingProgressComponent.vue?vue&type=template&id=677b8a90&scoped=true&"
import script from "./PostprocessingProgressComponent.vue?vue&type=script&lang=js&"
export * from "./PostprocessingProgressComponent.vue?vue&type=script&lang=js&"
import style0 from "./PostprocessingProgressComponent.vue?vue&type=style&index=0&id=677b8a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677b8a90",
  null
  
)

export default component.exports